import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.error.cause.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import { savePwd } from '@/request';
export default {
  name: 'ChangePwd',
  props: {
    username: {
      type: String,
      default: ''
    },
    hideOldPwd: {
      type: Boolean,
      default: false
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const form = ref({
      oldPassword: '',
      newPassword: '',
      confirmPwd: ''
    });
    const formRef = ref();

    function validPwd(rule, val, cb) {
      if (/\s+/.test(val)) {
        console.log(/\s+/.test(rule), rule);
        cb(new Error('不能输入空格'));
      }

      if (!/[a-z]+/.test(val)) {
        cb(new Error('密码必须包含小写字母'));
      }

      if (!/[A-Z]+/.test(val)) {
        cb(new Error('密码必须包含大写字母'));
      }

      if (!/[0-9]+/.test(val)) {
        cb(new Error('密码必须包含数字'));
      }

      cb();
    }

    function submit() {
      return new Promise(res => {
        const {
          newPassword,
          confirmPwd
        } = form.value;

        if (newPassword !== confirmPwd) {
          ElMessage.error('新密码2次输入不一致');
          return;
        }

        formRef.value.validate(e => {
          if (e) {
            savePwd(_objectSpread(_objectSpread({}, form.value), {}, {
              username: props.username,
              __repeat: true
            })).then(({
              data
            }) => {
              if (data.success) {
                ElMessage.success(data.message);
                formRef.value.resetFields();
                res(data);
              } else {
                ElMessage.error(data.message);
              }
            });
          }
        });
      });
    }

    expose({
      submit
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createBlock(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "80px"
      }, {
        default: _withCtx(() => [!__props.hideOldPwd ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "原密码",
          prop: "oldPassword",
          rules: {
            required: !__props.hideOldPwd,
            message: '原密码不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.oldPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.oldPassword = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["rules"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "新密码",
          prop: "newPassword",
          rules: [{
            required: true,
            message: '密码不可为空'
          }, {
            max: 16,
            min: 6,
            message: '密码长度为6-16'
          }, {
            validator: validPwd
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.newPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.newPassword = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_el_form_item, {
          label: "确认密码",
          prop: "confirmPwd",
          rules: [{
            required: true,
            message: '密码不可为空'
          }, {
            max: 16,
            min: 6,
            message: '密码长度为6-16'
          }, {
            validator: validPwd
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.confirmPwd,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.confirmPwd = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["model"]);
    };
  }

};